import React, { useEffect, useState } from "react";
import client from "../lib/api";
import { useSeo } from "../lib/useSeo";
import Layout, { Spinner } from "../components/Layout";
import { NewsCard } from "../components/NewsCard";

// Breaking news dedicated page
export default function Breaking() {
  const [items, setItems] = useState(null);
  useSeo({ title: "Breaking News", description: "Live breaking news from Rapid24News — Lucknow, Uttar Pradesh, India & World." });
  useEffect(() => { window.scrollTo(0, 0); client.get("/articles", { params: { breaking: true, limit: 24 } }).then((r) => setItems(r.data.items)); }, []);
  return (
    <Layout>
      <div className="bg-r24-red text-white">
        <div className="max-w-7xl mx-auto px-4 py-8 flex items-center gap-3">
          <span className="w-3 h-3 bg-white rounded-full animate-pulse" />
          <h1 className="font-head font-bold text-4xl md:text-5xl uc">Breaking News</h1>
          <span className="font-hindi text-white/80 text-lg">ब्रेकिंग न्यूज़</span>
        </div>
      </div>
      <section className="max-w-7xl mx-auto px-4 py-10">
        {!items ? <Spinner /> : items.length === 0 ? <p className="text-gray-500 py-16 text-center">No breaking stories right now.</p> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-testid="breaking-grid">
            {items.map((a) => <NewsCard key={a.slug} a={a} />)}
          </div>
        )}
      </section>
    </Layout>
  );
}
